import { useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _SIIFTCON6Value } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { SIIFTCON17Select } from '../../../admin/configuracion/SIIFTCON17/SIIFTCON17Select';
import { SiifAuxiliaryCatalogSelect } from '../../../admin/configuracion/SIIFAuxiliaryCatalog/SiifAuxiliaryCatalogSelect';
import { BasicTable, MASK_MONEY } from '../../../theme/Component/BasicTable';
import { ListMenu } from '../../../theme/Component/ListMenu';
import { Modal } from '../../../theme/Component/Modal';
import { ModalConfirm } from '../../../theme/Component/ModalConfirm';
import useModal, { MODAL_md, MODAL_SM } from '../../../theme/Component/hooks/useModal';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';
import { InputMoney } from '../../../theme/Input/InputMoney';

interface Props {
    accountantID?: string;
}

export const ConfigSIIFTCON6ValueByAccountantID = ({ accountantID }: Props) => {
    const { instance, lista, setLista, bean, setBean, update, deleteItemVoid, handleChange } = useDataBean(_SIIFTCON6Value);

    const modal = useModal('Agregar configuración TCON6', MODAL_md);
    const deleteModal = useModal('Eliminar configuración TCON6', MODAL_SM);

    const getLista = useCallback(() => {
        if (!accountantID) {
            setLista([]);
            return;
        }

        instance.getSIIFTCON6ValueByAccountantID(accountantID).then(
            (resp: any) => setLista(resp ?? [])
        ).catch((err: any) => toast.error(err));
    }, [accountantID]);


    useEffect(() => {
        getLista();
    }, [getLista]);


    const create = () => {
        if (!accountantID) {
            toast.warning('Debe seleccionar una cuenta contable.');
            return;
        }
        setBean({ AccountantIDStr: accountantID });
        modal.open('Agregar configuración TCON6');
    };

    const save = () => {
        if (!bean.IDSIIFAuxiliary) {
            toast.warning('Debe seleccionar un auxiliar SIIF.');
            return;
        }

        // if (!bean.IDSIIFTCON17Value) {
        //     toast.warning('Debe seleccionar un valor TCON17.');
        //     return;
        // }

        update()
            .then(() => {
                getLista();
                modal.close();
            })
            .catch((err: any) => toast.error(err));
    };

    const edit = () => {
        if (!bean.IDSIIFTCON6Value) {
            toast.warning('Debe seleccionar una configuración para editar.');
            return;
        }

        modal.open('Editar configuración TCON6');
    };

    const confirmDelete = () => {
        if (!bean.IDSIIFTCON6Value) {
            toast.warning('Debe seleccionar una configuración para eliminar.');
            return;
        }

        deleteModal.open();
    };


    const deleteItem = () => {
        const deletedId = bean.IDSIIFTCON6Value;

        deleteItemVoid(deletedId).then(
            (deleted: boolean) => {
                if (!deleted) {
                    toast.error('No fue posible eliminar la configuración TCON6.');
                    return;
                }
                getLista();
                deleteModal.close();
            }
        ).catch((err: any) => toast.error(err));
    };

    const head = [
        { title: 'ID', property: 'IDSIIFTCON6Value', visible: true },
        { title: 'Auxiliar', property: 'SIIFAuxiliaryName', visible: true },
        { title: 'TCON17', property: 'SIIFTCON17ValueName', visible: true },
        { title: 'Valor TCON6', property: 'TCon6Value', visible: true, mask: MASK_MONEY },
    ];

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create },
    ];

    const listButtons = (
        <ListMenu listaBotones={[
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: edit },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: confirmDelete },
        ]} />
    );

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    head={head}
                    body={lista}
                    rowSet={setBean}
                    listButtons={listButtons}
                    iconButtons={iconButtonsItem}
                />

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={save}>
                    <div className="row">
                        <div className="col-md-12">
                            <SiifAuxiliaryCatalogSelect
                                idSelector={bean.IDSIIFAuxiliary}
                                onChange={(value) => setBean({
                                    ...bean,
                                    IDSIIFAuxiliary: value,
                                })}
                            />
                        </div>
                        <div className="col-md-6">
                            <SIIFTCON17Select
                                idSelector={bean.IDSIIFTCON17Value}
                                onChange={(value) => setBean({
                                    ...bean,
                                    IDSIIFTCON17Value: value,
                                })}
                            />
                        </div>
                        <div className="col-md-6">
                            <label>Valor TCON6</label>
                            <InputMoney _value={bean.TCon6Value} onChange={(e) => { setBean({ ...bean, TCon6Value: e }) }} _label=" " />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={deleteModal.modal} updateModal={deleteModal.setModal} eventModal={deleteItem}>
                    <strong>¿Desea eliminar la configuración TCON6 seleccionada?</strong>
                </ModalConfirm>

            </div>
        </div>
    );
};
